<template>
  <div>
    <div
      class="ck-content"
      :class="{
        'tablet:aspect-4/3 bg-scheme-main p-7': options.isHighlighted,
      }"
      v-html="text"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  text?: string
}>()

const { options } = defineBlokkli({
  bundle: 'text',
  // This renders the component when the parent is the slider.
  renderFor: {
    parentBundle: 'slider',
  },
  options: {
    isHighlighted: {
      type: 'checkbox',
      label: 'Highlighted',
      default: false,
    },
  },
})
</script>
